(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function () {
    function initDrwChips() {
      document.querySelectorAll('.drw-cat-chips').forEach(function (group) {
        if (group.dataset.drwInit) return;
        group.dataset.drwInit = '1';
        var scope = group.parentElement;
        group.addEventListener('click', function (e) {
          var btn = e.target.closest('.drw-cat-chip');
          if (!btn) return;
          var filter = btn.getAttribute('data-drw-filter');
          group.querySelectorAll('.drw-cat-chip').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          scope.querySelectorAll('.product-grid__item').forEach(function (item) {
            var cat = item.getAttribute('data-drw-category');
            item.hidden = !(filter === 'all' || cat === filter);
          });
        });
      });
    }
    if (document.readyState !== 'loading') initDrwChips();
    else document.addEventListener('DOMContentLoaded', initDrwChips);
  })();

  } catch(e) { console.error(e); }
})();
})();
